import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cta_color: {
    id: 'cta_color',
    defaultMessage: 'Colore CTA',
  },
  primary: {
    id: 'primary',
    defaultMessage: 'Primario',
  },
  secondary: {
    id: 'secondary',
    defaultMessage: 'Secondario',
  },
  tertiary: {
    id: 'tertiary',
    defaultMessage: 'Terziario',
  },
  white: {
    id: 'white',
    defaultMessage: 'Bianco',
  },
});

export const removeListingVariation = (config, id) => {
  let indexOfVariation = -1;
  indexOfVariation =
    config.blocks?.blocksConfig?.listing?.variations?.findIndex(
      (x) => x.id === id,
    );
  if (indexOfVariation >= 0) {
    config.blocks.blocksConfig.listing.variations.splice(indexOfVariation, 1);
  }
};

export const addSchemaField = (
  schema,
  field,
  title,
  description,
  properties = {},
  position = 0,
) => {
  const defaultFieldsetIndex = schema.fieldsets.findIndex(
    (x) => x.id === 'default',
  );

  schema.fieldsets[defaultFieldsetIndex] = {
    ...schema.fieldsets[defaultFieldsetIndex],
  };
  schema.fieldsets[defaultFieldsetIndex].fields.splice(position, 0, field);
  schema.properties[field] = { title, description, ...properties };
};

export const addCtaColorField = (schema, intl) => {
  const linkMoreFieldsetIndex = schema.fieldsets.findIndex(
    (x) => x.id === 'linkmore',
  );

  const title = intl.formatMessage(messages.cta_color);

  const properties = {
    widget: 'color_list',
    colors: [
      { name: 'primary', label: intl.formatMessage(messages.primary) },
      { name: 'secondary', label: intl.formatMessage(messages.secondary) },
      { name: 'tertiary', label: intl.formatMessage(messages.tertiary) },
      { name: 'white', label: intl.formatMessage(messages.white) },
    ],
    defaultValue: 'white',
  };

  schema.fieldsets[linkMoreFieldsetIndex] = {
    ...schema.fieldsets[linkMoreFieldsetIndex],
  };

  schema.fieldsets[linkMoreFieldsetIndex].fields.splice(
    schema.fieldsets[linkMoreFieldsetIndex].fields.length,
    0,
    'cta_color',
  );
  schema.properties['cta_color'] = { title, ...properties };
};
